module.exports = __webpack_public_path__ + "img/calendar-2025.a64e2c58.png";